'use es6';

import mediaEmbedApi from './iframe-loader';
const apiExport = mediaEmbedApi();
window.hsMediaBridgeApi = apiExport;
export default window.hsMediaBridgeApi;